<template>
  <k-calendar
    :test="test"
    :weekSelect="!day && !purchasesSorting"
    :rangeSelect="purchasesSorting"
    @date="date => currentDayPicked = new Date(date)"
    @week="date => currentWeekPicked = date"
    @range="date => currentRangePicked = date"
    :currentSetDate="currentDayPicked"
    :currentSetWeek="currentWeekPicked"
    :currentSetRange="currentRangePicked"
    :style="{ 'pointer-events': !day && test ? 'none' : 'all' }"
  >
    <div class="k-filter__week-day-picker day-picker cursor-pointer" v-if="overloadDay ||day">
      <p>{{ getCurrentDayPicked }}</p>
      <svg width="13" height="15" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 0V2H13V0H15V2H16C17.1 2 18 2.9 18 4V18C18 19.1 17.1 20 16 20H2C0.89 20 0 19.1 0 18L0.00999999 4C0.00999999 2.9 0.89 2 2 2H3V0H5ZM16 7H2V18H16V7Z" fill="#F7981E"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10 9.5V11.5H12V13.5H9.999L10 15.5H8L7.999 13.5H6V11.5H8V9.5H10Z" fill="#F7981E"/>
      </svg>

    </div>
    <div v-else class="k-filter__week-day-picker week-picker my-3" :class="{ nowidth: purchasesSorting }">
      <div :class="{ enabled: !purchasesSorting && !test && !isPrevWeekNotAvaiable }" class="week-picker__arrow week-picker__arrow--left" @click.stop="setPrevWeek">
        <svg width="5" height="9" viewBox="0 0 5 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.87569 7.67963L1.11878 4.49982L4.87569 1.32001C5.04143 1.17547 5.04143 0.934579 4.87569 0.790042C4.70994 0.645506 4.4337 0.645506 4.21271 0.790043L0.12431 4.21075C-0.0414358 4.35529 -0.0414357 4.59618 0.12431 4.74072L4.15746 8.2096C4.3232 8.35414 4.59945 8.35414 4.82044 8.2096C5.04144 8.06506 5.04144 7.82417 4.87569 7.67963Z" fill="white"/>
        </svg>
      </div>
      <p class="week-picker__range cursor-pointer" v-if="!purchasesSorting">{{ getCurrentWeekPicked }}</p>
      <p class="week-picker__range cursor-pointer" v-else-if="overloadRange">{{ getCurrentRangePicked }}</p>
      <div v-if="!purchasesSorting" :class="{ enabled: !purchasesSorting && !test && !isNextWeekNotAvaiable }" class="week-picker__arrow week-picker__arrow--right" @click.stop="setNextWeek">
        <svg width="5" height="9" viewBox="0 0 5 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.124309 1.32037L3.88122 4.50018L0.12431 7.67999C-0.0414358 7.82453 -0.0414357 8.06542 0.12431 8.20996C0.290056 8.35449 0.566299 8.35449 0.787293 8.20996L4.87569 4.78925C5.04144 4.64471 5.04144 4.40382 4.87569 4.25928L0.842541 0.790399C0.676795 0.645862 0.400553 0.645862 0.179558 0.790399C-0.0414364 0.934936 -0.0414364 1.17583 0.124309 1.32037Z" fill="white"/>
        </svg>
      </div>
      <div v-if="purchasesSorting">
        <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 0V2H13V0H15V2H16C17.1 2 18 2.9 18 4V18C18 19.1 17.1 20 16 20H2C0.89 20 0 19.1 0 18L0.00999999 4C0.00999999 2.9 0.89 2 2 2H3V0H5ZM16 7H2V18H16V7Z" fill="#FFCC1B"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10 9.5V11.5H12V13.5H9.999L10 15.5H8L7.999 13.5H6V11.5H8V9.5H10Z" fill="#FFCC1B"/>
        </svg>
      </div>
    </div>
  </k-calendar>
</template>

<script>
import KCalendar from '../components/TheCalendar';
import dateFormat from '../utils/dateformat';
import { getMonday, dayNicifier } from '../utils/helper';
import { mapGetters } from 'vuex';

export default {
  components: { KCalendar },
  props: {
    day: {
      type: Boolean,
      default: false,
    },
    purchasesSorting: {
      type: Boolean,
      default: false,
    },
    test: {
      type: Boolean,
      default: false,
    },
    regular: {
      default: () => ({})
    },
    sync: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    currentDayPicked(value) {
      this.$emit('day', value);
    },
    currentWeekPicked(value) {
      this.$emit('week', value);
    },
    currentRangePicked(value) {
      this.$emit('range', value);
    },
  },

  data: () => ({
    defaultCurrentDayPicked: new Date(),
    currentWeekPicked: {
      from: getMonday(new Date()),
      to: (getMonday(new Date())).setDate((getMonday(new Date())).getDate() + 6)
    },
    defaultCurrentRangePicked: {
      from: getMonday(new Date()),
      to: (getMonday(new Date())).setDate((getMonday(new Date())).getDate() + 6)
    },
  }),

  computed: {
    overload() {
      return this.$store.getters.getOverload;
    },
    overloadDay() {
      return this.purchasesSorting && this.overload === 'day'
    },
    overloadRange() {
      return this.purchasesSorting && this.overload === 'range'
    },
    currentDayPicked: {
      get() {
        return this.sync
         ? this.getPurchaseDayPicked
         : this.defaultCurrentDayPicked
      },
      set(value) {
        this.sync
          ? this.$store.commit('updateDayDate', value)
          : this.defaultCurrentDayPicked = value
      }
    },
    currentRangePicked: {
      get() {
        console.log('WTF', this.getPurchaseRangePicked, this.defaultCurrentRangePicked)
        return this.sync
         ? this.getPurchaseRangePicked
         : this.defaultCurrentRangePicked
      },
      set(value) {
        this.sync
          ? this.$store.commit('updateRangeDate', value)
          : this.defaultCurrentRangePicked = value
      }
    },
    isNextWeekNotAvaiable() {
      if (!this.regular.id) return true;

      const notAvailMonday = (getMonday(new Date())).setDate((getMonday(new Date())).getDate() + 21)
      const notAvailMondayZeroTime = new Date(new Date(notAvailMonday).setHours(0,0,0,0));

      const nextMonday = (getMonday(new Date(this.currentWeekPicked.to))).setDate((getMonday(new Date(this.currentWeekPicked.to))).getDate() + 7)
      const nextMondayZeroTime = new Date(new Date(nextMonday).setHours(0,0,0,0));

      return new Date(nextMondayZeroTime).getTime() >= new Date(notAvailMondayZeroTime).getTime()
    },
    isPrevWeekNotAvaiable() {
      if (!this.regular.id) return true;

      const notAvailMonday = (getMonday(new Date())).setDate((getMonday(new Date())).getDate() - 7)
      const notAvailMondayZeroTime = new Date(new Date(notAvailMonday).setHours(0,0,0,0));

      const prevMonday = (getMonday(new Date(this.currentWeekPicked.to))).setDate((getMonday(new Date(this.currentWeekPicked.to))).getDate())
      const prevMondayZeroTime = new Date(new Date(prevMonday).setHours(0,0,0,0));

      return new Date(prevMondayZeroTime).getTime() <= new Date(notAvailMondayZeroTime).getTime()
    },
    getCurrentDayPicked() {
      return dateFormat(this.currentDayPicked, 'dd mmmm')
    },
    getCurrentWeekPicked() {
      return `${dateFormat(this.currentWeekPicked.from, 'dd mmmm')} - ${dateFormat(this.currentWeekPicked.to, 'dd mmmm')}`
    },
    getCurrentRangePicked() {
      return `${dateFormat(this.currentRangePicked.from, 'dd mmmm')} - ${this.currentRangePicked.to ? dateFormat(this.currentRangePicked.to, 'dd mmmm') : ''}`
    },
    ...mapGetters([
      'getUser',
      'getUserSevenDaysLeft',
      'getPurchaseDayPicked',
      'getPurchaseRangePicked',
    ])
  },

  methods: {
    setTrialWeek() {
      const niceDay = dayNicifier(this.getUser.created_at);
      this.currentWeekPicked = {
        from: new Date(niceDay),
        to: new Date(niceDay).setDate((new Date(niceDay)).getDate() + 6)
      }
      this.currentDayPicked =  new Date(niceDay)
    },
    setPrevWeek() {
      const d_from = new Date(this.currentWeekPicked.from);
      const d_to = new Date(this.currentWeekPicked.to);
      const from = d_from.setDate(d_from.getDate() - 7);
      const to = d_to.setDate(d_to.getDate() - 7);

      this.currentWeekPicked = {
        from,
        to,
      }
    },
    setNextWeek() {
      const d = new Date(this.currentWeekPicked.from);
      d.setDate(d.getDate() + 7);

      this.currentWeekPicked = {
        from: new Date(d),
        to: (new Date(d)).setDate((new Date(d)).getDate() + 6)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.k-filter__week-day-picker {
  display: flex;
  align-items: center;
}

.day-picker,
.week-picker {
  width: 280px;
  display: flex;
  justify-content: space-between;
}
.week-picker {
  max-width: 280px;
  user-select: none;

  &.nowidth {
    max-width: unset;
    width: unset;
    align-items: center;
    justify-content: center;

    .week-picker__range {
      margin-right: 15px;
    }
  }
}
.week-picker__range {
  margin: 0;
  cursor: pointer;
}
.week-picker__arrow {
  width: 22px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FFCC1B;
  border-radius: 50%;
  margin: 0 7px;

  opacity: 0;
  pointer-events: none;

  &.inactive {
    opacity: 0.5;
  }
  &.enabled {
    opacity: 1;
    pointer-events: all;
  }
}

.day-picker {
  border: 1px solid #FFCC1B;
  box-sizing: border-box;
  border-radius: 20px;
  height: 24px;
  justify-content: space-between;
  padding: 0 10px;
  p {
    margin: 0;
    font-size: 14px;
    color: #616161;
  }
}

@media (max-width: 767.98px) {
  .day-picker {
    justify-content: center;
    p {
      margin-right: 20px;
    }
  }
}
</style>